import React, { useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { X, ArrowUpRight, LayoutGrid } from "lucide-react";

function Item({ it, count, onClose }) {
  const Icon = it.icon;
  return (
    <NavLink to={it.to} onClick={onClose} className={({ isActive }) => `v3-item${isActive ? " actief" : ""}`} data-testid={`v3-paneel-item-${it.tid}`}>
      {Icon ? <Icon /> : null}
      <span className="min-w-0 flex-1">
        <span className="v3-nm block truncate">{it.label}</span>
        {it.beschrijving && <span className="v3-sub block truncate">{it.beschrijving}</span>}
      </span>
      {count > 0 && <span className="v3-badge">{count > 99 ? "99+" : count}</span>}
    </NavLink>
  );
}

/** Hub-paneel naast de menubalk: modules van de hub per groep (rechten bepalen zoals altijd wat erin staat). */
export function V3HubPaneel({ hub, counts, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    const toets = (e) => { if (e.key === "Escape") { onClose(); document.querySelector(`[data-testid="v3-hub-${hub.key}"]`)?.focus(); } };
    const klik = (e) => { if (ref.current && !ref.current.contains(e.target) && !e.target.closest?.(".v3-side")) onClose(); };
    document.addEventListener("keydown", toets);
    document.addEventListener("mousedown", klik);
    return () => { document.removeEventListener("keydown", toets); document.removeEventListener("mousedown", klik); };
  }, [hub.key, onClose]);
  useEffect(() => { ref.current?.querySelector("a")?.focus({ preventScroll: true }); }, [hub.key]);
  const groepen = Object.entries(hub.items.reduce((acc, it) => ((acc[it.subgroup] = acc[it.subgroup] || []).push(it), acc), {}));
  const Icon = hub.icon;
  return (
    <div ref={ref} role="dialog" aria-label={`${hub.label} — modules`} className={`v3-paneel${hub.items.length > 9 ? " breed" : ""}`} data-testid="v3-hub-paneel">
      <div className="v3-ph">
        <span className="v3-av" style={{ borderRadius: 8 }}><Icon className="h-4 w-4" /></span>
        <div className="min-w-0 flex-1">
          <h2>{hub.label} <span className="v3-sub" style={{ fontSize: 12, fontWeight: 400, color: "var(--v3-ink-3)" }}>{hub.items.length} modules</span></h2>
          <p>{hub.uitleg}</p>
        </div>
        <button type="button" className="v3-iconbtn" onClick={onClose} aria-label="Sluiten" data-testid="v3-hub-paneel-sluiten"><X /></button>
      </div>
      <div className="v3-body">
        <div className="v3-kolommen">
          {groepen.map(([sub, items]) => (
            <section key={sub} data-testid={`v3-paneel-groep-${String(sub).replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase()}`}>
              <div className="v3-grp">{sub}</div>
              {items.map((it) => <Item key={it.to} it={it} count={it.counter ? counts[it.counter] || 0 : 0} onClose={onClose} />)}
            </section>
          ))}
        </div>
      </div>
      <div className="v3-pf">
        <Link to={hub.hubTo} onClick={onClose} className="v3-lnk inline-flex items-center gap-1 text-[13px]" data-testid="v3-hub-paneel-start">Startpagina {hub.label} <ArrowUpRight className="h-3.5 w-3.5" /></Link>
        <Link to="/alle-tools" onClick={onClose} className="v3-lnk inline-flex items-center gap-1 text-[13px]" data-testid="v3-hub-paneel-alle"><LayoutGrid className="h-3.5 w-3.5" /> Alle tools</Link>
      </div>
    </div>
  );
}
